import { FC } from 'react';
import { composeHoc } from '../../utils/compose';
import { SearchListComponent } from './list';
import { withEmptyList } from './with-empty';
import { withLoadingList } from './with-loading';
import { ISearchListProps } from './interface';

export const SearchList: FC<ISearchListProps> = composeHoc(
  withLoadingList,
  withEmptyList
)(SearchListComponent);
